import { render, staticRenderFns } from "./ReturnsMethodology.vue?vue&type=template&id=483a9d28&"
import script from "./ReturnsMethodology.vue?vue&type=script&lang=js&"
export * from "./ReturnsMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports